export default function VacancyCard({ mall, value }) {
    return (
        <div className="card h-100">
            <div className="card-body">
                <div className="d-flex text-center flex-column text-dark pt-2 h-100 justify-content-between">
                    <span className="fw-bold fs-7">{mall}</span>
                    <div className="d-flex align-items-center justify-content-center pt-2">
                        <span className="fw-bolder fs-2x pt-1">{value}%</span>
                    </div>
                </div>
            </div>
        </div>
    )
}
